//

//
import activityIndex from '@/views/dataStatistics/activityIndex';
import attentionRateIndex from '@/views/dataStatistics/attentionRateIndex';

// 数据统计
import platformDataStatisticsIndex from '@/views/dataStatistics/platformDataStatistics/index';
import moduleDataStatisticsIndex from '@/views/dataStatistics/moduleDataStatistics/index';
import moduleDataStatisticsDetail from '@/views/dataStatistics/moduleDataStatistics/detail';
import moduleDataStatisticsUsage from '@/views/dataStatistics/moduleDataStatistics/usage';
import kitDataStatisticsIndex from '@/views/dataStatistics/kitDataStatistics/index';
import kitDataStatisticsDetail from '@/views/dataStatistics/kitDataStatistics/detail';
import trailRecordAccounting from '@/views/dataStatistics/trailRecordAccounting';

import schoolAppList from '@/views/schoolManage/schoolAppManage/schoolAppList';

export default [
    {
        path: 'dataAnalysis',
        redirect: 'dataAnalysis/activityIndex'
    },
    // 活跃度
    {
        path: 'dataAnalysis/activityIndex',
        component: activityIndex
    },
    // 关注率
    {
        path: 'dataAnalysis/attentionRateIndex',
        component: attentionRateIndex
    },
    // 数据统计
    {
        path: 'dataAnalysis/dataStatistics/platformDataStatistics/index',
        component: platformDataStatisticsIndex,
    },
    {
        path: 'dataAnalysis/dataStatistics/moduleDataStatistics/index',
        component: moduleDataStatisticsIndex,
        meta: {
            isCached: true
        }
    },
    {
        path: 'dataAnalysis/dataStatistics/moduleDataStatistics/detail',
        component: moduleDataStatisticsDetail,
    },
    {
        path: 'dataAnalysis/dataStatistics/moduleDataStatistics/usage',
        component: moduleDataStatisticsUsage,
    },
    {
        path: 'dataAnalysis/dataStatistics/kitDataStatistics/index',
        component: kitDataStatisticsIndex,
        meta: {
            isCached: true
        }
    },
    {
        path: 'dataAnalysis/dataStatistics/kitDataStatistics/detail',
        component: kitDataStatisticsDetail,
    },
    {
        path: 'dataAnalysis/mobileBankAccounting/mobileBankAccountingList',
        component: () => import('@/views/mobileBankAccounting/mobileBankAccountingList')
    },
    {
        path: 'dataAnalysis/mobileBankAccounting/mobileBankAccountingDetail',
        component: () => import('@/views/mobileBankAccounting/mobileBankAccountingDetail')
    },
    {
        path: 'dataAnalysis/mobileBankAccounting/mobileBankActiveAccounting',
        component: () => import('@/views/mobileBankAccounting/mobileBankActiveAccounting')
    },
    {
        path: 'dataAnalysis/mobileBankAccounting/mobileBankActiveAccountingBySchool',
        component: () => import('@/views/mobileBankAccounting/mobileBankActiveAccountingBySchool')

    },
    {
        path: 'dataAnalysis/mobileBankAccounting/mobileBankDataReport',
        component: () => import('@/views/mobileBankAccounting/mobileBankDataReport')
    },
    {
        path: 'dataAnalysis/mobileBankAccounting/abcModuleVisitStat',
        component: () => import('@/views/mobileBankAccounting/abcModuleVisitStat')
    },
    {
        path: 'dataAnalysis/mobileBankAccounting/abcModuleVisitStatDetail',
        component: () => import('@/views/mobileBankAccounting/abcModuleVisitStatDetail')
    },
    {
        path: 'dataAnalysis/mobileBankAccounting/schoolAppList',
        component: schoolAppList
    },
    {
        path: 'dataAnalysis/trailRecordAccounting',
        component: trailRecordAccounting
    },
    
]



// WEBPACK FOOTER //
// ./src/router/modules/dataAnalysis.js